import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ApresentacaoService {
  getLinhaTempo() {
    return [
      {
        id: 1,
        edição: 'Primeira edição',
        evolucao: '185 cursos, 21 cursos do eixo militar',
        data: 'Julho 2008',
        ano: 2008,
        nome: 'cnct_1a_edicao.pdf',
      },
      {
        id: 2,
        edição: 'Segunda edição',
        evolucao: '220 cursos, 13 Eixos Tecnológicos, Orientações cursos experimentais',
        data: 'Julho 2012',
        ano: 2012,
        nome: 'cnct_2a_edicao.pdf',
      },
      {
        id: 3,
        edição: 'Terceira edição',
        evolucao: '227 cursos, 13 Eixos Tecnológicos, Comissão de atualização do Catálogo (CONPEP)',
        data: 'Dezembro 2014',
        ano: 2014,
        nome: 'cnct_3a_edicao.pdf',
      },
    ];
  }
}
